<div class="card mb-3">
  <div class="card-body py-3">
    <div class="row align-items-end">
      <div class="col-md-2 mb-2">
        <label class="mb-1 font-weight-semi-bold">Begin date</label>
        <input type="date" class="form-control form-control-sm" [(ngModel)]="begDate">
      </div>

      <div class="col-md-2 mb-2">
        <label class="mb-1 font-weight-semi-bold">End date</label>
        <input type="date" class="form-control form-control-sm" [(ngModel)]="endDate">
      </div>

      <div class="col-md-2 mb-2">
        <label class="mb-1 font-weight-semi-bold">Status</label>
        <select class="form-control form-control-sm" [(ngModel)]="statusId">
          <option [value]="0">All Statuses</option>
          <option *ngFor="let s of statusObj" [value]="s.id">{{ s.name }}</option>
        </select>
      </div>

      <div class="col-md-3 mb-2">
        <label class="mb-1 font-weight-semi-bold">Search</label>
        <input type="text"
               class="form-control form-control-sm"
               [(ngModel)]="searchText"
               (input)="onSearchChange()"
               placeholder="Order no, user, segment, date...">
      </div>

      <div class="col-md-1 mb-2">
        <button class="btn btn-primary btn-sm btn-block" (click)="loadReport()">
          <span class="fas fa-search"></span>
        </button>
      </div>

      <div class="col-md-2 mb-2">
        <button class="btn btn-success btn-sm btn-block" (click)="exportToExcel()">
          <span class="fas fa-file-excel mr-1"></span> Export
        </button>
      </div>
    </div>
  </div>
</div>

<div class="card mb-3">
  <div class="card-body py-3">
    <div class="row justify-content-between align-items-center">
      <div class="col-sm-auto mb-2 mb-sm-0">
        <h6 class="mb-0">
          Showing {{ pagedData.length }} of {{ filteredData.length }} orders
        </h6>
      </div>

      <div class="col-sm-auto text-right">
        <span class="badge badge-soft-info mr-2 p-2">
          Total Qty: {{ totalQty }}
        </span>
        <span class="badge badge-soft-success p-2">
          Total Price: {{ totalPrice | number:'1.2-2' }} ₼
        </span>
      </div>
    </div>
  </div>
</div>

<div class="card">
  <div class="card-body p-0">
    <div class="table-responsive scrollbar">
      <table class="table table-sm table-dashboard fs--1 mb-0">
        <thead class="slb-header fs--1">
          <tr>
            <th class="align-middle pl-3">#</th>
            <th class="align-middle">Order ID</th>
            <th class="align-middle">Order No</th>
            <th class="align-middle">User</th>
            <th class="align-middle">Seg. Level 1</th>
            <th class="align-middle">Seg. Level 2</th>
            <th class="align-middle">Seg. Level 3</th>
            <th class="align-middle">Date</th>
            <th class="align-middle">Status</th>
            <th class="align-middle text-center">Total Qty</th>
            <th class="align-middle text-right pr-3">Total Price</th>
          </tr>
        </thead>

        <tbody *ngIf="!isLoading && pagedData.length > 0">
          <tr *ngFor="let item of pagedData; let i = index">
            <td class="align-middle pl-3">
              {{ ((currentPage - 1) * pageSize) + i + 1 }}
            </td>
            <td class="align-middle">{{ item.orderId }}</td>
            <td class="align-middle font-weight-semi-bold text-bold">
              {{ item.orderNo }}
            </td>
            <td class="align-middle">{{ item.userName }}</td>
            <td class="align-middle segment-cell">{{ item.segment1 }}</td>
            <td class="align-middle segment-cell">{{ item.segment2 }}</td>
            <td class="align-middle segment-cell">{{ item.segment3 }}</td>
            <td class="align-middle">{{ item.date }}</td>
            <td class="align-middle">
              <span class="badge badge-pill badge-soft-{{item.statusCss}} px-3 py-2">
                {{ item.status }}
              </span>
            </td>
            <td class="align-middle text-center">
              <span class="badge badge-soft-info px-2 py-1">
                {{ item.totalQty }}
              </span>
            </td>
            <td class="align-middle text-right pr-3 font-weight-semi-bold">
              {{ item.totalPrice | number:'1.2-2' }} ₼
            </td>
          </tr>
        </tbody>

        <tbody *ngIf="isLoading">
          <tr>
            <td colspan="8" class="text-center py-5">
              <div class="spinner-border spinner-border-sm text-primary mr-2"></div>
              Loading...
            </td>
          </tr>
        </tbody>

        <tbody *ngIf="!isLoading && pagedData.length === 0">
          <tr>
            <td colspan="8" class="text-center py-5 text-500">
              No data found
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>

  <div class="card-footer d-flex justify-content-between align-items-center py-2">
    <small class="text-500">
      Page {{ currentPage }} / {{ totalPages }}
    </small>

    <nav>
      <ul class="pagination pagination-sm mb-0">
        <li class="page-item" [class.disabled]="currentPage === 1">
          <a class="page-link" href="javascript:void(0)" (click)="changePage(currentPage - 1)">Prev</a>
        </li>

        <li class="page-item" *ngFor="let p of pages" [class.active]="p === currentPage">
          <a class="page-link" href="javascript:void(0)" (click)="changePage(p)">{{ p }}</a>
        </li>

        <li class="page-item" [class.disabled]="currentPage === totalPages">
          <a class="page-link" href="javascript:void(0)" (click)="changePage(currentPage + 1)">Next</a>
        </li>
      </ul>
    </nav>
  </div>
</div>
